import React, { useState } from "react";
import { soinsGrille, contact } from "../mock";
import { Sparkles, Instagram, MessageCircle } from "lucide-react";

const categories = ["Tous", "Visage", "Corps", "Massages", "Pieds", "Regard", "Épilation", "Maquillage", "Nouveautés"];

const Soins = () => {
  const [active, setActive] = useState("Tous");
  const filtered = active === "Tous" ? soinsGrille : soinsGrille.filter((s) => s.category === active);

  return (
    <section id="soins" className="py-24 md:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="font-serif text-[11px] tracking-[0.35em] text-gold-dark mb-6">NOS PRESTATIONS</p>
          <h2 className="font-serif text-4xl md:text-6xl text-brown leading-tight">
            Quel soin<br />
            <span className="font-vibes text-gold-dark text-5xl md:text-7xl">est fait pour vous ?</span>
          </h2>
          <div className="gold-divider my-8">
            <span className="w-1.5 h-1.5 rounded-full bg-gold" />
          </div>
          <p className="font-cormorant italic text-brown/75 text-lg md:text-xl">
            Des soins sur-mesure pour révéler votre beauté et votre bien-être.
          </p>
          <div className="mt-6 inline-block bg-taupe/30 px-6 py-2">
            <p className="font-serif text-[11px] tracking-[0.3em] text-brown">VOTRE SÉRÉNITÉ EST MA PRIORITÉ</p>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-12">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActive(cat)}
              className={`px-5 py-2 text-[11px] tracking-[0.2em] uppercase border transition-all duration-300 ${
                active === cat
                  ? "bg-gold text-cream border-gold"
                  : "bg-transparent text-brown border-taupe/60 hover:border-gold hover:text-gold-dark"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {filtered.map((s, idx) => (
            <div
              key={s.id}
              className="service-card bg-cream border border-taupe/40 p-6 flex flex-col group"
            >
              <div className="flex items-start justify-between mb-4">
                <Sparkles size={16} className="text-gold-dark" strokeWidth={1.3} />
                <span className="font-serif text-[10px] tracking-widest text-brown/60">
                  {String(idx + 1).padStart(2, "0")}/{String(filtered.length).padStart(2, "0")}
                </span>
              </div>
              <p className="font-serif text-[10px] tracking-[0.25em] text-brown/70 uppercase mb-3 min-h-[36px]">
                {s.question}
              </p>
              <h3 className="font-vibes text-3xl text-gold-dark leading-tight mb-3">
                {s.name}
              </h3>
              <p className="font-cormorant text-brown/80 text-[15px] leading-relaxed flex-grow">
                {s.desc}
              </p>
              <div className="flex items-center justify-between mt-5 pt-4 border-t border-taupe/40">
                <div>
                  <p className="font-serif text-[10px] tracking-widest text-brown/60">TARIF</p>
                  <p className="font-serif text-sm text-gold-dark">{s.price}</p>
                </div>
                {s.duration && (
                  <span className="font-serif text-[9px] tracking-[0.25em] text-brown/60">{s.duration}</span>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-14">
          <p className="font-cormorant italic text-brown/75 text-lg mb-5">
            Vous ne savez pas quel soin choisir ?<br />
            Écrivez-moi en message privé, je serai ravie de vous conseiller.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <a
              href={contact.whatsappUrl}
              target="_blank"
              rel="noreferrer"
              className="btn-outline-gold"
            >
              <MessageCircle size={14} strokeWidth={1.6} />
              Réserver sur WhatsApp
            </a>
            <a
              href={contact.instagramUrl}
              target="_blank"
              rel="noreferrer"
              className="btn-gold"
            >
              <Instagram size={14} strokeWidth={1.6} />
              Réserver sur Instagram
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Soins;
